<template>
        <nav class="to-rigth">
        <ul>
            <!-- Add font awesome icons -->
            <li class="list"><a href="https://wa.me/+573185106016" target="_blank" class="fa fa-whatsapp" aria-label="WhatsApp"></a></li>
            <li class="list"><a href="https://www.facebook.com/merengonbavaro91/" target="_blank" class="fa fa-facebook" aria-label="Facebook"></a></li>
            <li class="list"><a href="https://www.instagram.com/merengonbavaro" target="_blank" class="fa fa-instagram" aria-label="Instagram"></a></li>
        </ul>
    </nav>
</template>
<script>
    export default {
        data () {
            return {
            }
        }
    }
</script>
<style scoped>
        .fa {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            padding: 0;
            font-size: 22px;
            text-align: center;
            text-decoration: none;
            margin: 6px 0;
            border-radius: 50%;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
            transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
        }

        .fa:hover {
            opacity: 0.9;
            transform: translateY(-3px) scale(1.05);
            box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35);
        }

        .fa-whatsapp {
            background: #25D366;
            color: white;
        }

        .fa-facebook {
            background: #3B5998;
            color: white;
        }

        .fa-instagram {
            background: radial-gradient(circle at 30% 110%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
            color: white;
        }

        .to-rigth {
            position: fixed !important;
            bottom: 100px !important;
            right: 20px !important;
            z-index:1000 !important;
        }

        .to-rigth ul {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0;
            margin: 0;
        }

        .list {
            list-style-type: none;
        }

        @media (max-width: 575px) {
            .to-rigth {
                bottom: 90px !important;
                right: 10px !important;
            }

            .fa {
                width: 38px;
                height: 38px;
                font-size: 17px;
                margin: 4px 0;
                box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
            }

            /* Evita duplicar el CTA de WhatsApp que ya está en el header */
            .fa-whatsapp {
                display: none;
            }
        }
</style>